import producer from 'immer';
import { Reducer } from 'redux';
import { HistoricoState, HistoricoType } from './types';

const INITIAL_STATE: HistoricoState = {
  data: [],
  detalhe: [],
  resetPage: 0,
  cleanModal: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<HistoricoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HistoricoType.HISTORICO_RESQUEST:
      return producer(state, draft => {
        draft.loading = true;
      });
    case HistoricoType.HISTORICO_SUCCESS:
      return producer(state, draft => {
        draft.data = action.payload.data;
        draft.loading = false;
      });
    case HistoricoType.HISTORICO_FAILURE:
      return producer(state, draft => {
        draft.loading = false;
        draft.error = true;
      });
    case HistoricoType.DETALHE_HISTORICO_RESQUEST:
      return producer(state, draft => {
        draft.loading = true;
      });
    case HistoricoType.DETALHE_HISTORICO_SUCCESS:
      return producer(state, draft => {
        draft.detalhe = action.payload.data;
        draft.loading = false;
      });
    case HistoricoType.DETALHE_HISTORICO_FAILURE:
      return producer(state, draft => {
        draft.loading = false;
        draft.error = true;
      });

    case HistoricoType.RESET_PAGE:
      return producer(state, draft => {
        draft.resetPage = draft.resetPage + 1;
      });
    case HistoricoType.CLEAN_MODAL:
      return producer(state, draft => {
        draft.cleanModal = draft.cleanModal + 1;
      });

    default:
      return state;
  }
};

export default reducer;
